export default __webpack_public_path__ + "static/media/img_introduce_benefit_4.e5f71444.png";